import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {LicenseState, FetchLicensesResponse, FetchLicenseByIdResponse} from './types'
import {
  fetchLicenseById,
  fetchLicenses,
  createLicense,
  updateLicense,
  deleteLicense,
  suspendLicense,
  activateLicense,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: LicenseState = {
  licenseForEdit: null,
  licenses: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    resetLicenses: (state: LicenseState) => {
      state.licenses = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLicenses.pending, (state: LicenseState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchLicenses.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchLicenses.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicensesResponse>) => {
        state.listLoading = false
        state.error = null
        const {licenses, total, totalPages} = action.payload
        state.licenses = licenses
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchLicenseById.pending, (state: LicenseState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchLicenseById.rejected,
      (state: LicenseState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchLicenseById.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.listLoading = false
        state.error = null
        state.licenseForEdit = action.payload.license
      }
    )

    builder.addCase(createLicense.pending, (state: LicenseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createLicense.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createLicense.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateLicense.pending, (state: LicenseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateLicense.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateLicense.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteLicense.pending, (state: LicenseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteLicense.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteLicense.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendLicense.pending, (state: LicenseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendLicense.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendLicense.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateLicense.pending, (state: LicenseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(activateLicense.rejected, (state: LicenseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      activateLicense.fulfilled,
      (state: LicenseState, action: PayloadAction<FetchLicenseByIdResponse>) => {
        state.licenseForEdit = action.payload.license
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default licenseSlice.reducer
export const actions = licenseSlice.actions
